<template>
    <div class="full-width-record" ref="joinHallItemRecordDom" v-loading="loading">
        <el-row :gutter="12">
            <el-col :span="colSpan" v-for="(v, i) in recordList" :key="v.id" style="margin-bottom: 12px;">
                <JoinHallItem :item="v" @clickHide="hideItem" @clickShow="showItem" @clickEdit="editItem" />
            </el-col>
        </el-row>

        <paginationComponent :pageObj="pageObj" @goPage="changePage" />
    </div>
</template>

<script setup>
    import JoinHallItem from "@/components/shopopee/hall/joinHallItem.vue";
    import paginationComponent from "@/components/shopopee/common/paginationComponent"
    import {toRef, ref, onMounted, getCurrentInstance, inject} from "vue";
    import { useUserinfo } from '@/stores/userinfo'
    import myUtil from "@/util/util";
    import materialApi from "@/request/materialApi";
    import eshopopeeApi from "@/request/eshopopeeApi";

    const emits = defineEmits(["goEdit"])

    const { proxy } = getCurrentInstance()
    const i18n = inject("i18n")

    const { getShopCompanyObj } = inject('shopControlFunc', { getShopCompanyObj: () => { return {} } })

    const shopCompany = ref({})
    const width = ref(425)
    const colSpan = ref(24)

    const userInfoRef = toRef(useUserinfo())

    const pageObj = ref({})
    const recordList = ref([])

    const loading = ref(false)

    const pageNum = ref(1)
    const pageSize = ref(5)

    let currObj = null

    function getShopItemList(){
        loading.value = true
        const request = materialApi.queryMaterialByPage
        const params = request.getParams()

        params.companycode = shopCompany.value.companycode
        // params.memberid = userInfoRef.value.businessId
        params.pageNum = pageNum.value
        params.pageSize = pageSize.value

        request.send(params, fillShopItem)
    }

    function fillShopItem(res){
        loading.value = false

        if (res.code == 200){
            pageObj.value = res.detail
            recordList.value = res.detail.list
        }else{
            myUtil.alertError(res.msg)
            recordList.value = []
            res.detail = {}
        }
    }

    function hideItem(obj){
        myUtil.confirmWarning(i18n.tkey("lang_hide_item_confirm"), () => {
            toggleItemDisplay(obj.id, 0)
        })
    }

    function showItem(obj){
        myUtil.confirmWarning(i18n.tkey("lang_show_item_confirm"), () => {
            toggleItemDisplay(obj.id, -1)
        })
    }

    function toggleItemDisplay(id, value){
        loading.value = false

        const request = materialApi.updateShopItem
        const params = request.getParams()

        params.id = id
        params.updatedid = value

        request.send(params, (res) => {
            if (res.code == 200){
                myUtil.alertSuccess(i18n.tkey("lang_save_success"))
                getShopItemList()
            }else{
                myUtil.alertError(res.msg)
            }
        })

    }

    function changePage(page){
        pageNum.value = page

        getShopItemList()

    }

    function editItem(obj){
        emits("goEdit", obj)
    }

    onMounted(() => {
        width.value = proxy.$refs.joinHallItemRecordDom.offsetWidth

        if (width.value > 1800){
            colSpan.value = 4
            pageSize.value = 12
        }else if (width.value > 1200){
            colSpan.value = 6
            pageSize.value = 8
        }else if (width.value > 900){
            colSpan.value = 8
            pageSize.value = 6
        }else if(width.value > 600){
            colSpan.value = 12
            pageSize.value = 6
        }else{
            colSpan.value = 12
            pageSize.value = 4
        }

        shopCompany.value = getShopCompanyObj()
        getShopItemList()
    })
</script>

<style scoped>
    .full-width-record {
        width: 100%;
    }
</style>